import React from 'react';

const Loader = () => {
    return (
        <div className="loader">
            <span />
            <div />
            <div />
            <div />
            <div />
            <div />
        </div>
    );
}

export default Loader;
